import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCrnkI6dCe8Su-vfDBB-oljYrHZz0Ni7DE",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "hxcode-d78n.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "hxcode-d78n",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "hxcode-d78n.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "183858416963",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:183858416963:web:9956f2df25d6a67d23b3f6",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-77PF58C44K",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

export let messaging = null;
try {
  messaging = getMessaging(app);
} catch {
  // FCM not supported in all environments (e.g. Safari without SW)
}

export default app;
